import moment                 from 'moment'
import { Calendar }           from '@fullcalendar/core';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import dayGridPlugin          from '@fullcalendar/daygrid';
import timeGridPlugin         from '@fullcalendar/timegrid';
import interactionPlugin      from '@fullcalendar/interaction';

import { CalendarActions } from "../actions/calendar"
import { OnSchedRest } from "../../OnSchedRest"
import { OnSchedHelpers } from "../../utils/OnSchedHelpers";
import { OnSchedTemplates } from '../../OnSchedTemplates';


export const CalendarElement = element => {
  // Get Appointments
  const el = document.getElementById(element.id);

  // Set Calendar Template
  el.innerHTML = OnSchedTemplates.CalendarTmpl();

  // Begin Calendar Loading
  OnSchedHelpers.CalendarLoading(element, true);
  
  // Set Default Calendar View
  const defaultView = OnSchedHelpers.CalendarViews[element.options.defaultView?.toLowerCase()];

  // Create Calendar from fullCalendar Module
  const calendarEl = document.getElementById('onsched-full-calendar');

  // Get IANA Time Zone names for tzOffset
  const timezonesUrl = `${element.onsched.setupApiBaseUrl}/companies/timezones/${element.params.date ? element.params.date : moment().format('YYYY-MM-DD')}`;
  
  // Track touchstart event to block dateClick on swipe
  let touchStart = 0;
  el.addEventListener('touchstart', e => {
    touchStart = e.changedTouches[e.changedTouches.length - 1].clientX;
  })

  
  var locationsUrl = `${element.onsched.setupApiBaseUrl}/locations`;
  if (element.params.locationId) {
    locationsUrl = `${element.onsched.setupApiBaseUrl}/locations/${element.params.locationId}`;
  }
  
  OnSchedRest.Get(locationsUrl, locationsResponse => {
    // Set the location in question
    const onschedLocation = element.params.locationId ? locationsResponse : locationsResponse.data.filter(l => l.primaryBusiness)[0];
    
    OnSchedRest.Get(timezonesUrl, timezonesResponse => {
      if (timezonesResponse.error) {
        console.log('Error loading time zones')
      }
      else {
        let servicesUrl = element.onsched.apiBaseUrl + `/services?limit=1`
        if (element.params.locationId) {
          servicesUrl = OnSchedHelpers.AddUrlParam(servicesUrl, 'locationId', element.params.locationId);
        }

        // Get all Services and mount Calendar with first Service found
        OnSchedRest.Get(servicesUrl, servicesResponse => {
          if (servicesResponse.error) {
            // Throw error
          }
          else {
            // let getResourcesUrl = element.onsched.apiBaseUrl + '/resources';
            // getResourcesUrl = OnSchedHelpers.AddUrlParam(getResourcesUrl, element.params.locationId, element.params.locationId);
            // getResourcesUrl = OnSchedHelpers.AddUrlParam(getResourcesUrl, element.params.resourceGroupId, element.params.resourceGroupId);

            // var resourcesLoaded = resourcesResponse.data;

            // let timeZone = !OnSchedHelpers.IsEmpty(element.params.tzOffset) ? timezonesResponse.timezones.filter(tz => tz.tzOffset === element.params.tzOffset)[0]?.timezoneIanna : 'local'
            let timeZone = !OnSchedHelpers.IsEmpty(element.params.timezoneName) ? element.params.timezoneName : 'local'
            if (!timeZone) timeZone = 'local';
    
            // Create function to mount the Calendar Element with a Service ID
            // **NOTE** Remove the requirement for a Service ID once Availability request can be made without a Service ID
            const mountCalendar = () => {
              const serviceId = OnSchedHelpers.IsEmpty(element.params.serviceId) ? servicesResponse.data[0].id : element.params.serviceId;
              
              const calendar = new Calendar(calendarEl, {
                plugins: [ resourceTimeGridPlugin, timeGridPlugin, dayGridPlugin, interactionPlugin ],
                schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
                themeSystem: 'standard',
                
                timeZone,
                navLinks: true,
                editable: false,
                dayMaxEventRows: 3,
                dayMaxEvents: 3,
                eventResourceEditable: true,
                refetchResourcesOnNavigate: false,
                nowIndicator: true,
                allDaySlot: false,
                weekends: element.options.hideWeekends ? !element.options.hideWeekends : true,
                firstDay: element.options.startWeekOnMonday ? true : false,
                dayPopoverFormat: { month: 'short', day: 'numeric' },
                fixedWeekCount: false,
                // moreLinkClick:   e => setTimeout(() => {
                //   // console.log(document.querySelector('.fc-popover-title'), e)
                // }, 50),
                
                viewDidMount:    e => CalendarActions.ViewChange(e, element, calendar),
                scrollTime:      moment().format('hh:mm:ss'),
                // businessHours:   CalendarActions.BusinessHours(element, calendar, onschedLocation),
                eventConstraint: "businessHours",
                initialView:     OnSchedHelpers.IsEmpty(defaultView) ? 'resourceTimeGridDay' : defaultView,
                slotDuration:    !OnSchedHelpers.IsEmpty(element.options.interval) ? `00:${element.options.interval}:00` : '00:30:00',
                initialDate:     element.params.date ? element.params.date : moment().format('YYYY-MM-DD'),
                eventClick:      e => CalendarActions.SelectAppointment(e, element, calendar, servicesResponse.data),
                resources:       (info, success, failure) => CalendarActions.CalendarResources(element, calendar, success, failure),
                eventChange:     (e) => CalendarActions.CalendarRescheduleApptModal(element, e, calendar),
                events:          (info, successCallback, failureCallback) => CalendarActions.CalendarEvents(element, calendar, serviceId, info, successCallback, failureCallback),
                eventContent:    (e) => OnSchedHelpers.CustomEventContent(element, e),
                eventClassNames: OnSchedHelpers.CalendarEventClassNames,
                headerToolbar:   OnSchedHelpers.HeaderToolbar,
                dayHeaderContent: e => CalendarActions.DayHeaderContent(e, calendar),
                dateClick:       e => CalendarActions.CreateAppointment(calendar, element, e, serviceId, servicesResponse.data, touchStart),
                datesSet:        e => CalendarActions.DatesSet(e, element),
                resourcesSet:    () => CalendarActions.ResourcesCallback(element, calendar),
                
                customButtons:   { 
                  refresh: { text: ' \u21ba	', click: () => calendar.refetchEvents() },
                  customDay: { icon: 'calendar-day', click: () => calendar.refetchEvents() }
                },
              });
            
              // Render the Calendar with all above configurations
              calendar.render();

              // Create Toolbar actions
              CalendarActions.HeaderToolbar(calendar, element);
                            
              // End Calendar Loading
              // OnSchedHelpers.CalendarLoading(element, false);
          
              // Create Toolbar actions
              CalendarActions.TrackpadNavigation(calendar, element);
          
              // Style calendar to match OnSched Element dimensions
              document.querySelector('.fc-view-harness').style.minHeight = el.clientHeight + 'px';

              OnSchedHelpers.UtilityCustomEvents.ElementLoaded(element);
            }
        
            mountCalendar();
          }
        })
      }
    })
  })
}
